import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { testimonialsContent } from "../data/testimonialsContent";
import SectionYellowTitle from "../components/common/SectionYellowTitle";
import WistiaVideo from "../components/common/WistiaVideo";
import ScheduleCallButton from "../components/common/ScheduleCallButton";

const SuccessStoriesPage: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        py: 6,
        my: 6,
        mt: { xs: 12, md: 10, lg: 10 },
      }}
    >
      <Container>
        {/* Títulos */}
        <SectionYellowTitle title={testimonialsContent.sectionLabel} />
        <Typography
          variant="h2"
          gutterBottom
          sx={{
            fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" },
            fontWeight: "bold",
            color: "text.primary",
            textAlign: { xs: "left", md: "left" },
            py: { xs: 2, md: 2 },
          }}
        >
          {testimonialsContent.title}
        </Typography>

        {/* videos  */}
        <Grid container spacing={4} sx={{ mt: 4 }}>
          {testimonialsContent.allTestimonials.map((testimonials, index) => (
            <Grid size={{ xs: 12, md: 6, lg: 4 }} key={index}>
              <Card
                sx={{
                  bgcolor: "background.paper",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {testimonials.video.wistiaId && (
                  <WistiaVideo mediaId={testimonials.video.wistiaId} />
                )}
                <CardContent sx={{ flexGrow: 1 }}>
                  <Stack spacing={1}>
                    <Typography variant="body1" color="text.primary">
                      "{testimonials.text.quotes}"
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      color="primary"
                      fontWeight={600}
                    >
                      {testimonials.text.author}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {testimonials.text.role}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box textAlign="center" mt={6}>
          <ScheduleCallButton
            label="Schedule a Call"
            // ghlUrl="https://api.leadconnectorhq.com/widget/booking/pvSPIagh7QDeGS6U9rxB"
          />
        </Box>
      </Container>
    </Box>
  );
};

export default SuccessStoriesPage;
